import {
    TabContent as BootstrapTabContent,
    Nav,
    NavItem,
    NavLink,
    TabPane
} from "reactstrap";
import { useEffect, useRef } from "react";

import Breadcrumbs from "@components/ui-components/breadcrumbs";
import { ComponentSpinner } from "../../spinner";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classnames from "classnames";
import size from "lodash/size";
import { useTranslation } from "react-i18next";

const TabHeader = ({
    active,
    toggle = () => {},
    centered = false,
    fill = false,
    vertical = false,
    horizontalScroll = false,
    tabs,
    headerClassName = "",
    id = ""
}) => {
    const { t } = useTranslation();
    const activeTabRef = useRef(null);
    useEffect(() => {
        if (activeTabRef.current) {
            activeTabRef.current.scrollIntoView({
                behavior: "instant",
                block   : "end"
            });
        }
    }, [active]);

    return size(tabs) ? (
        <Nav
            tabs
            data-tour={`${id}-tabs`}
            className={classnames("custom-scroll", {
                "justify-content-center": centered,
                "nav-left"              : vertical,
                "horizontal-scroll"     : horizontalScroll,
                [headerClassName]       : headerClassName
            })}        
            fill={fill}>
            {tabs.map(
                (item) => !item.omit && (
                    <NavItem data-cy={item.testId} key={item.id}>
                        <NavLink
                            innerRef={item.id === active ? activeTabRef : null}
                            active={active === item.id}
                            data-cy={item.id}
                            {...(item.to && { to: item.to, tag: Link })}
                            {...(toggle) && { onClick: () => {
                                toggle(item.id);
                            } }}>
                            {t(item.name)}
                        </NavLink>
                    </NavItem>
                )
            )}
        </Nav>
    ) : null;
};

TabHeader.propTypes = {
    active          : PropTypes.any.isRequired,
    toggle          : PropTypes.func,
    centered        : PropTypes.bool,
    fill            : PropTypes.bool,
    vertical        : PropTypes.bool,
    horizontalScroll: PropTypes.bool,
    tabs            : PropTypes.array.isRequired,
    headerClassName : PropTypes.string,
    id              : PropTypes.string
};

// TabContent Component
const TabContent = ({ tabs = [], active, vertical = false, loading = false, contentClass = "" }) => (
    loading ? (
        <ComponentSpinner />
    ) : size(tabs) ? (
        <BootstrapTabContent activeTab={active}
            className={classnames({
                [contentClass]: contentClass
            })}>
            {tabs.map(
                (item) => !item.omit && active === item.id && (
                    <TabPane
                        className={classnames({
                            "nav-left border-start": vertical,
                            [contentClass]         : contentClass
                        })}
                        tabId={item.id}
                        key={item.id}>
                        {item.content}
                    </TabPane>
                )
            )}
        </BootstrapTabContent>
    ) : null);

TabContent.propTypes = {
    tabs        : PropTypes.array,
    active      : PropTypes.any.isRequired,
    vertical    : PropTypes.bool,
    loading     : PropTypes.bool,
    contentClass: PropTypes.string
};

// TabsView Component
const TabsView = (props) => {
    const { vertical = false, breadcrumbItems = [] } = props;
    return (
        <>
            {size(breadcrumbItems) ? <Breadcrumbs {...breadcrumbItems} /> : null}
            <div
                className={classnames("common-tabs", {
                    "nav-vertical": vertical
                })}>
                <TabHeader {...props} />
                <TabContent {...props} />
            </div>
        </>
    );
};

TabsView.propTypes = {
    vertical       : PropTypes.bool,
    breadcrumbItems: PropTypes.array
};

export { TabHeader, TabContent, TabsView };
